/* Women Essentials:
   1) Al cambiar de variante con los botones, actualiza los packs.
   2) El precio grande de arriba muestra el precio del pack elegido (Individual, Dúo, 3x2…). */
(function () {
  if (window.__weVariantSync) return;
  window.__weVariantSync = true;

  function toNumber(t) {
    var clean = String(t).replace(/[^0-9,\.]/g, '');
    if (clean.indexOf(',') > -1) clean = clean.replace(/\./g, '').replace(',', '.');
    var n = parseFloat(clean);
    return isNaN(n) ? 0 : n;
  }

  function syncTopPrice() {
    document.querySelectorAll('.quantity-breaks').forEach(function (qb) {
      var checked = qb.querySelector('input[name="quantity"]:checked');
      if (!checked) return;
      var wrap = checked.closest('.quantity-break-wrapper') || checked.parentElement;
      var p = wrap && wrap.querySelector('.quantity-break__price');
      if (!p) return;
      var c = wrap.querySelector('.quantity-break__compare-price');
      var info = qb.closest('.product__info-container') || document;
      var priceEl = info.querySelector('.price');
      if (!priceEl) return;
      var pt = p.textContent.trim();
      var ct = c ? c.textContent.trim() : '';
      priceEl.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--last').forEach(function (el) {
        el.textContent = pt;
      });
      var s = priceEl.querySelector('.price__sale s.price-item--regular');
      if (ct && s && ct !== pt) {
        s.textContent = ct;
        priceEl.classList.add('price--on-sale');
        var badge = priceEl.querySelector('.price__badge-sale');
        var pn = toNumber(pt), cn = toNumber(ct);
        if (badge && pn && cn && cn > pn) {
          var pct = Math.round((cn - pn) / cn * 100);
          var nodes = Array.prototype.filter.call(badge.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
          var label = 'Ahorras ' + pct + '%';
          if (nodes.length) { nodes[nodes.length - 1].textContent = ' ' + label; }
          else { badge.appendChild(document.createTextNode(' ' + label)); }
        }
      } else {
        priceEl.classList.remove('price--on-sale');
      }
    });
  }


  /* Cantidad (+ / −): el precio de arriba muestra precio × unidades */
  function fmt(n, sample) {
    var txt = n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return /€\s*$/.test(sample) ? txt + ' €' : '€' + txt;
  }
  function syncQtyPrice() {
    document.querySelectorAll('.we-qty .quantity__input').forEach(function (input) {
      var info = input.closest('.product__info-container') || document;
      var priceEl = info.querySelector('.price');
      if (!priceEl) return;
      var qty = Math.max(1, parseInt(input.value, 10) || 1);
      var targets = priceEl.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--last, .price__sale s.price-item--regular');
      targets.forEach(function (el) {
        if (!el.dataset.weUnit) el.dataset.weUnit = el.textContent.trim();
        var unit = toNumber(el.dataset.weUnit);
        if (unit) el.textContent = fmt(unit * qty, el.dataset.weUnit);
      });
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.we-qty .quantity__input')) syncQtyPrice();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.we-qty .quantity__button')) setTimeout(syncQtyPrice, 0);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.quantity-breaks input[name="quantity"]')) {
      setTimeout(syncTopPrice, 0);
    }
  });

  function init() {
    syncTopPrice();
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      var d = evt && evt.data;
      if (!d || !d.html || !d.sectionId) return;
      var id = 'quantity-breaks-' + d.sectionId;
      var current = document.getElementById(id);
      var fresh = d.html.getElementById ? d.html.getElementById(id) : d.html.querySelector('#' + id);
      if (current && fresh) {
        var checked = current.querySelector('input[name="quantity"]:checked');
        var value = checked ? checked.value : null;
        var clone = document.importNode(fresh, true);
        current.replaceWith(clone);
        if (value) {
          var radio = clone.querySelector('input[name="quantity"][value="' + value + '"]');
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        clone.querySelectorAll('.quantity-break__variant-select').forEach(function (s) {
          s.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      setTimeout(function () { syncTopPrice(); syncQtyPrice(); }, 0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();